<app-dialog-header title="Run History" (closeClicked)="onClose()">
</app-dialog-header>

<mat-dialog-content class="fullscreen-dialog">
  <app-run-history-entry-grid [runHistory]="data.runHistory"></app-run-history-entry-grid>
</mat-dialog-content>